export function CheckeredFlagIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" aria-hidden="true">
      <line
        x1="4"
        y1="3"
        x2="4"
        y2="22"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <rect
        x="4.5"
        y="3.5"
        width="15"
        height="10"
        stroke="currentColor"
        strokeWidth="1.25"
        rx="0.5"
      />
      <rect x="4.5" y="3.5" width="5" height="5" fill="currentColor" />
      <rect x="14.5" y="3.5" width="5" height="5" fill="currentColor" />
      <rect x="9.5" y="8.5" width="5" height="5" fill="currentColor" />
    </svg>
  );
}
